import Models from '../models';

/**
 * @ngdoc service
 * @name eventix.common.services.AskAPI
 * @description
 * Service to handle requests to `/api/ask`. A flexible API endpoint that returns the data you ask for.
 *
 * The service is split into different functions (a HTTP request, and its parser) to facilitate a pre-boot
 * request and restoration during bootstrapping.
 *
 * @example
 * <pre>
 * AskAPI.ask(authTokens).then( function(httpResponse){
 *    AskAPI.restore(httpResponse);
 * });
 * </pre>
 */
export default angular.module('eventix.common.services.askapi',[Models])
    .factory('AskAPI', function($http, EventLocation, User, MetaData, Product, Company, Whitelabel,
        Event, EventDate, Ticket, Collapse, PaymentMethod, $q, Role, Shop, ProductGroup, $log) {
        return {
            ask: ask,
            restore: restore
        };

        /**
     * @ngdoc method
     * @name eventix.common.services.AskAPI#ask
     * @methodOf eventix.common.services.AskAPI
     * @description
     * Send a request to `/api/ask`
     *
     * @param {Object} tokens A set of OAuth2 tokens
     * @param {String[]} models Optional list of model data to ask for. Defaults to everything.
     * @returns {Promise} The `$http` request
     */
        function ask(tokens = {}, models = null) {
            return $q.reject('DEPRECATED');
        //return $http({
        //    method: 'POST',
        //    url: DASHBOARD_API_ROOT + '/ask',
        //    headers: {
        //        'Content-Type': 'application/json',
        //        Authorization: tokens.access_token
        //    },
        //    data: {
        //        models: models || ['events',
        //            'users',
        //            'roles'
        //        ]
        //            'products',
        //            'tickets',
        //            'locations',
        //            'metadata',
        //            'shops',
        //            'groups'
        //        ],
        //        pivots: pivots || [
        //            'events-products',
        //            'events-tickets',
        //            'products-eventDates',
        //            'products-tickets',
        //            'products-metadata',
        //            'shops-products',
        //            'shops-tickets',
        //            'tickets-groups'
        //        ]
        //    }
        //});
        }

        /**
     * @ngdoc method
     * @name eventix.common.services.AskAPI#restore
     * @methodOf eventix.common.services.AskAPI
     * @description
     * Parse the response from an `#ask` call
     *
     * @param {Object} results The `$http` response
     * @returns {Promise} Resolves with events from the data
     */
        function restore(results) {
            var events;
            if(_.has(results, 'data.global_products')) {
                _.forEach(results.data.global_products, (product) => {
                    let containerProduct = false;
                    if(product.pricing_method === 'container')
                        containerProduct = true;
                    Product.new(Object.assign(product, {
                        isGlobalProduct: true,
                        isContainerProduct: containerProduct,
                    }))
                })
                Product.cachedQueries.cache()
            }
            if(_.has(results,'data.metaData')) {
                _.forEach(results.data.metaData, MetaData.new);
                MetaData.cachedQueries.cache();
            }
            if(_.has(results,'data.locations')) {
                _.forEach(results.data.locations, EventLocation.new);
                EventLocation.cachedQueries.cache();
            }
            if(_.has(results,'data.products')) {
                _.forEach(results.data.products, Product.new);
                Product.cachedQueries.cache();
            }
            if(_.has(results,'data.users')) {
                _.forEach(results.data.users, User.new);
                User.cachedQueries.cache();
            }
            if(_.has(results,'data.groups')) {
                _.forEach(results.data.groups, ProductGroup.new);
                ProductGroup.cachedQueries.cache();
            }
            if(_.has(results,'data.tickets')) {
                _.forEach(results.data.tickets, Ticket.new);
                Ticket.cachedQueries.cache();
            }
            if(_.has(results,'data.roles')) {
                _.forEach(results.data.roles, Role.new);
                Role.cachedQueries.cache();
            }
            if(_.has(results,'data.shops')) {
                _.forEach(results.data.shops, Shop.new);
                Shop.cachedQueries.cache();
            }

            if(_.has(results,'data.companies')) {
                events = _.map(results.data.companies, Company.new);
                Company.cachedQueries.cache();
            }
            if(_.has(results,'data.brandings')) {
                events = _.map(results.data.brandings, Whitelabel.new);
                Whitelabel.cachedQueries.cache();
            }
            if(_.has(results,'data.events')) {
                events = _.map(results.data.events, Event.new);
                Event.cachedQueries.cache();
            }
            if(_.has(results,'data.collapses')) {
                _.forEach(results.data.collapses, Collapse.new);
                Collapse.cachedQueries.cache();
            }
            if(_.has(results,'data.paymentmethods')) {
                let methods = results.data.paymentmethods;
                _.forEach(methods, method => {
                    method.total_transaction_percentage = Number(Math.round(_.get(method.fees, 'self.percentages', 0) +_.get(method.fees, 'other.percentages', 0)+'e2')+'e-2');
                    method.total_transaction_fixed = _.get(method.fees, 'self.fixed', 0) + _.get(method.fees, 'other.fixed', 0);
                });
                _.forEach(methods, PaymentMethod.new);
                PaymentMethod.cachedQueries.cache();
            }

            if(_.has(results,'data.eventDates')) {
                var dates = _.map(results.data.eventDates, EventDate.new);
                EventDate.cachedQueries.cache();
                if(_.has(results,'data.events')) {
                    _.forEach(events, event => {
                        EventDate.cachedQueries.cache({ event_id: event.guid });
                        var evDates = _.filter(dates, date => {
                            return date.event_id === event.guid && !/^2099-01-01/.test(date.start);
                        });
                        if(evDates.length) {
                            let minDate = _.minBy(evDates, d => moment(d.start).format('x'));
                            let maxDate = _.maxBy(evDates, d => moment(d.end).format('x'));
                            let offsetStart = moment.parseZone(minDate.start).utcOffset();
                            let offsetEnd = moment.parseZone(minDate.end).utcOffset();
                            event.start = minDate.start;
                            event.start_raw = moment.utc(minDate.start).utcOffset(offsetStart).format('ddd DD-MMM-YYYY HH:mm');
                            event.end = maxDate.end;
                            event.end_raw = moment.utc(maxDate.end).utcOffset(offsetEnd).format('ddd DD-MMM-YYYY HH:mm');
                        }
                    });
                }
            }

            _.forEach(_.get(results,'data.pivots'), (pivotRows, pivotName) => {
                _.forEach(pivotRows, row => {
                    let product, eventDate, ticket, metaData, shop, pivot, group, collapse, paymentmethod, event;
                    switch(pivotName) {
                        case 'events-products':
                            product = Product.cached[row.product_guid];
                            event = Event.cached[row.event_guid];
                            event.belongsToMany.cache('Product', product);
                            break;
                        case 'events-tickets':
                            ticket = Ticket.cached[row.ticket_guid];
                            event = Event.cached[row.event_guid];
                            event.belongsToMany.cache('Ticket', ticket);
                            break;
                        case 'products-eventDates':
                            product = Product.cached[row.product_guid];
                            eventDate = EventDate.cached[row.event_date_guid];
                            product.belongsToMany.cache('EventDate', eventDate);
                            eventDate.belongsToMany.cache('Product', product);
                            event = Event.cached[eventDate.event_id];
                            event.belongsToMany.cache('Product', product);
                            break;
                        case 'products-tickets':
                            product = Product.cached[row.product_guid];
                            ticket = Ticket.cached[row.ticket_guid];
                            pivot = {
                                price: row.price,
                                forced: row.forced,
                                preceded_by: row.preceded_by
                            };
                            product.belongsToMany.cache('Ticket', ticket, pivot);
                            ticket.belongsToMany.cache('Product', product, pivot);
                            break;
                        case 'products-metadata':
                            product = Product.cached[row.product_guid];
                            metaData = MetaData.cached[row.metadata_guid];
                            pivot = {
                                preceded_by: row.preceded_by
                            };
                            product.belongsToMany.cache('MetaData', metaData, pivot);
                            break;
                        case 'shops-products':
                            shop = Shop.cached[row.shop_guid];
                            product = Product.cached[row.product_guid];
                            pivot = {
                                preceded_by: row.preceded_by
                            };
                            shop.belongsToMany.cache('Product', product, pivot);
                            break;
                        case 'shops-tickets':
                            shop = Shop.cached[row.shop_guid];
                            ticket = Ticket.cached[row.ticket_guid];
                            pivot = {
                                preceded_by: row.preceded_by
                            };
                            shop.belongsToMany.cache('Ticket', ticket, pivot);
                            break;
                        case 'shops-metadata':
                            shop = Shop.cached[row.shop_guid];
                            metaData = MetaData.cached[row.metadata_guid];
                            pivot = {
                                preceded_by: row.preceded_by
                            };
                            shop.belongsToMany.cache('MetaData', metaData, pivot);
                            break;
                        case 'tickets-groups':
                            group = ProductGroup.cached[row.group_guid];
                            ticket = Ticket.cached[row.ticket_guid];
                            pivot = {
                                preceded_by: row.preceded_by
                            };
                            group.belongsToMany.cache('Ticket', ticket);
                            ticket.belongsToMany.cache('ProductGroup', group, pivot);
                            break;
                        case 'shops-collapses':
                            shop = Shop.cached[row.shop_guid];
                            collapse = Collapse.cached[row.collapse_guid];
                            pivot = {
                                preceded_by: row.preceded_by
                            };
                            shop.belongsToMany.cache('Collapse', collapse, pivot);
                            break;
                        case 'shops-paymentmethods':
                            shop = Shop.cached[row.shop_id];
                            paymentmethod = PaymentMethod.cached[row.payment_method_id];
                            pivot = {
                                preceded_by: row.preceded_by
                            };
                            shop.belongsToMany.cache('PaymentMethod', paymentmethod, pivot);
                            break;
                        default:
                            $log.debug('Unknown pivot:', pivotName);
                    }
                });
            });
            return $q.resolve(events);
        }
    }).name;
